import {
  Label,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function SelectDemo() {
  return (
    <Section
      id="select"
      title="Select"
      description="Single-select dropdown."
    >
      <VariantBlock label="Default size">
        <div className="grid w-72 gap-1.5">
          <Label htmlFor="select-experience">Experience type</Label>
          <Select>
            <SelectTrigger id="select-experience">
              <SelectValue placeholder="Pick one" />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                <SelectLabel>AISquare experiences</SelectLabel>
                <SelectItem value="aiko">Aiko</SelectItem>
                <SelectItem value="metric-stream">MetricStream</SelectItem>
                <SelectItem value="graphify">Graphify</SelectItem>
              </SelectGroup>
              <SelectSeparator />
              <SelectGroup>
                <SelectLabel>Studio</SelectLabel>
                <SelectItem value="creator">Creator Studio</SelectItem>
                <SelectItem value="ai-studio">AI Studio</SelectItem>
              </SelectGroup>
            </SelectContent>
          </Select>
        </div>
      </VariantBlock>

      <VariantBlock label="Small size">
        <Select>
          <SelectTrigger size="sm" className="w-40">
            <SelectValue placeholder="sm trigger" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="a">Item A</SelectItem>
            <SelectItem value="b">Item B</SelectItem>
            <SelectItem value="c">Item C</SelectItem>
          </SelectContent>
        </Select>
      </VariantBlock>

      <VariantBlock label="Disabled">
        <Select disabled>
          <SelectTrigger className="w-40">
            <SelectValue placeholder="Disabled" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="never">never</SelectItem>
          </SelectContent>
        </Select>
      </VariantBlock>
    </Section>
  );
}
